const sviluppo = {
    API_ENDPOINT_URL: 'http://localhost:8080',
    URL_NEWSLETTER:"https://app.us9.list-manage.com/subscribe/post?u=73c196eb1dea0d14dc789f653&amp;id=5bd0d4b8ec&amp;f_id=005011e1f0",
    API_KEY_GOOGLE:"AIzaSyBCB4y0SztfLo236n4JECwTvIQd-VecF2Y"

};

const collaudo = {
    API_ENDPOINT_URL: 'https://0x5clzaaxj.execute-api.eu-central-1.amazonaws.com/latest',
    URL_NEWSLETTER:"https://app.us9.list-manage.com/subscribe/post?u=73c196eb1dea0d14dc789f653&amp;id=5bd0d4b8ec&amp;f_id=005011e1f0",
    API_KEY_GOOGLE:"AIzaSyBCB4y0SztfLo236n4JECwTvIQd-VecF2Y"


};

const produzione = {
    API_ENDPOINT_URL: 'https://ol0nwt8kcj.execute-api.eu-central-1.amazonaws.com/prod',
    URL_NEWSLETTER:"https://besthousecilento.us13.list-manage.com/subscribe/post?u=e0dc1d9cceb1f3af219c554d7&amp;id=1f11eb7cf6&amp;f_id=00492ee2f0",
    API_KEY_GOOGLE:"AIzaSyBCB4y0SztfLo236n4JECwTvIQd-VecF2Y"

};

const getEnv = () => {
    console.log(process.env)
    switch (process.env.REACT_APP_ENV) {
        case 'development':
            return sviluppo
        case 'staging':
            return collaudo
        case 'production':
            return produzione
        default:
            return produzione;
    }
}

export const env = getEnv()
